import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Collapse,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveRoom } from './hooks/useSaveRoom';
import { useRoomLabel } from '../../hooks/useRoomLabel';

export default function RoomFormModal({ open, onClose, onSave, room }) {
  const navigate = useNavigate();
  const roomLabel = useRoomLabel();
  const { save: saveRoom } = useSaveRoom();
  const [formName, setFormName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setFormName(room?.name ?? '');
      setError('');
    }
  }, [open, room]);

  const save = () => {
    if (!formName.trim()) return;

    const payload = {
      name: formName,
    };

    saveRoom(room ? room.id : null, payload)
      .then(() => {
        onSave();
        onClose();
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/expired-session');
        } else {
          setError(err.response?.data ?? roomLabel.saveErrorMessage);
        }
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {room ? roomLabel.editTitle : roomLabel.newTitle}
      </DialogTitle>
      <DialogContent>
        <Collapse in={!!error} sx={{ mb: 1 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {error}
          </Alert>
        </Collapse>
        <TextField
          autoFocus
          label="Nome"
          fullWidth
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
          inputProps={{ 'data-cy': 'room-name' }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={save}
          disabled={!formName.trim()}
          data-cy="save-room-btn"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

RoomFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  room: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }),
};

RoomFormModal.defaultProps = {
  room: null,
};
